import { BaseElement } from './base-element';

export const ERASER = new BaseElement(99, 'Eraser', 34, 56.15, 26.4, 'eraser.dae');



// WEBPACK FOOTER //
// ./src/app/eraser.ts